<template>
  <div class="right-mid-chart-left">
    <!-- right top chart title  -->
    <h6 class="chart-title">
      {{ $t('dashboard.titles.dividends') }}
      <span class="hover-action">
        <span>{{ $t('dashboard.dividends.fact') }} </span>
      </span>
      <span class="title-question-icon" @click.prevent="toggleHelp()">
        <iquestion />
      </span>
      <!-- 
        <span class="hover-action">
          <span class="text">фактические</span>
          <span class="view-item">
            <a href="#"> в годовом выражении</a>
          </span>
        </span>
        <span class="float-right right-bar-icon">
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11 1H17V7"
            stroke="#00A6CB"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
          <path
            d="M7 17H1V11"
            stroke="#00A6CB"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
          <path
            d="M16.5003 1.5L10.667 7.33333"
            stroke="#00A6CB"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
          <path
            d="M1.5 16.5L7.33333 10.6666"
            stroke="#00A6CB"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
        </svg>
        <span
          class="settings-tab-text-icon multi-collapse collapse"
          :class="{ show: $store.state.layout.settingsOpened }"
          id="setting-overlay"
          style=""
        >
          <i class="fa fa-eye"></i>
        </span>
      </span> -->
    </h6>
    <div class="settings-tab">
      <div class="right-top-chart-table" :class="{ 'no-content': noContent }">
        <p v-if="noContent">{{ $t('dashboard.dividends.noContent') }}</p>
        <table class="table-cover" v-else>
          <tbody>
            <tr class="table-header-sort-title">
              <th class="single-sort-title">
                <div class="col-title">
                  {{ $t('dashboard.dividends.dateT2') }}
                </div>
              </th>
              <th class="single-sort-title">
                <div class="col-title">
                  {{ $t('dashboard.dividends.status') }}
                </div>
              </th>
              <th class="single-sort-title">
                <div class="col-title">
                  {{ $t('dashboard.dividends.period') }}
                </div>
              </th>
              <th class="single-sort-title">
                <div class="col-title">
                  {{ $t('dashboard.dividends.divValue') }}
                </div>
              </th>
            </tr>
            <tr
              class="single-content-items"
              v-for="(div, i) in dividents"
              :key="i"
            >
              <td>{{ div.date | date }}</td>
              <td class="custom-size">{{ status(div.status) }}</td>
              <td class="custom-size">
                {{ period(div.period) }}
              </td>
              <td class="custom-size">
                {{ div.currency === 'dollars' ? '$' : ''
                }}{{ div.currency === 'euros' ? '€' : ''
                }}{{ div.currency === 'pounds' ? '£' : ''
                }}{{ financial(div.volume)
                }}{{ div.currency === 'rubles' ? '₽' : '' }}
                <span>{{ profit(div) | percent }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="settings-tab-overlay multi-collapse collapse"
        :class="{ show: $store.state.layout.settingsOpened }"
        id="setting-overlay"
        style=""
      ></div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import _ from 'lodash'
import moment from 'moment'
import iquestion from '@/components/icons/question'
import { statusMap, periodMap } from '@/utils/dividends'

export default {
  data() {
    return {
      mode: 'fact',
    }
  },
  computed: {
    noContent() {
      return this.dividents.length === 0
    },
    ...mapState('ticker', {
      dividents: (state) => {
        return state.dividents
          .map((el) => ({
            ...el,
            date: el.lastDivDay,
            volume: el.dividend,
            currency: el.currency || 'rubles',
            currencyRatio: el.currencyRatio || 1,
          }))
          .sort((a, b) => {
            return moment(b.date) - moment(a.date)
          })
      },
    }),
  },
  methods: {
    toggleHelp() {
      this.$store.commit('layout/updateModal', {
        modal: 'help',
        show: true,
        title: this.$t('modals.references.dividends.title'),
        content: this.$t('modals.references.dividends.content'),
        subtitle: this.$t('modals.messages.reference'),
      })
    },
    profit(div) {
      // if (div.status == 'forecast' || div.status == 'recommended')
      if (
        !moment(div.date)
          .add(1, 'day')
          .isBefore()
      )
        // >= date
        return (
          (div.volume * div.currencyRatio) /
          this.$store.state.market.currentPrice
        )
      return (div.dividend * div.currencyRatio) / div.basisDivPrice
    },
    financial(value) {
      if (_.isUndefined(value)) return ''
      return _.isNumber(value)
        ? value.toFixed(this.$store.state.market.digitsAfterDot)
        : value === null
        ? '?'
        : String(value)
    },
    status: statusMap,
    period: periodMap,
  },
  filters: {
    percent(value) {
      if (_.isUndefined(value)) return ''
      return `${(value * 100).toFixed(2)}%`
    },
    date(value) {
      const d = moment(value)
      if (d.isValid()) return d.format('DD.MM.YYYY')
      return '?'
    },
  },
  components: {
    iquestion: iquestion,
  },
}
</script>

<style lang="scss"></style>
